import React, { createContext, useState, useEffect, useContext } from 'react';
import { AppContext } from './AppContexts';
import { toast } from 'react-toastify';

export const EventContext = createContext();

export const EventProvider = ({ children }) => {
    const [events, setEvents] = useState([]);
    const [individualEvents, setIndividualEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const { userData } = useContext(AppContext)

    // Fetch events
    const fetchEvents = async () => {
        setLoading(true);
        const EVENTS_ENDPOINT = import.meta.env.VITE_APP_BASE_ENDPOINT + '/mainapp/events/'

        try {
            setLoading(true);
            // Make API call to fetch events
            const response = await fetch(EVENTS_ENDPOINT);
            const data = await response.json();
            setEvents(data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching events:', error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    //Fetch individual user events
    const fetchUserEvents = async () => {
        const EVENTS_ENDPOINT = import.meta.env.VITE_APP_BASE_ENDPOINT + `/mainapp/events/?user_id=${userData.user_data.user_id}`

        try {

            // Make API call to fetch events
            const response = await fetch(EVENTS_ENDPOINT);
            const data = await response.json();
            setIndividualEvents(data);

        } catch (error) {
            console.error('Error fetching events:', error);

        }
    }

    // Post resource
    const postResource = async (newResource) => {
        try {
            setLoading(true);
            // Make API call to post resource
            const response = await fetch('https://api.example.com/events', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newResource),
            });
            const data = await response.json();
            setEvents([...events, data]);
            setLoading(false);
        } catch (error) {
            console.error('Error posting resource:', error);
            setLoading(false);
        }
    };

    // Edit resource
    const editResource = async (id, updatedResource) => {
        try {
            setLoading(true);
            // Make API call to edit resource
            const response = await fetch(`https://api.example.com/events/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatedResource),
            });
            const data = await response.json();
            const updatedevents = events.map((resource) =>
                resource.id === id ? data : resource
            );
            setEvents(updatedevents);
            setLoading(false);
        } catch (error) {
            console.error('Error editing resource:', error);
            setLoading(false);
        }
    };

    // Delete resource
    const deleteEvent = async (id) => {
        console.log('Yo evt', id)
        const EVENTS_ENDPOINT = import.meta.env.VITE_APP_BASE_ENDPOINT + `/mainapp/events/${id}/`

        try {
            // setLoading(true);
            // Make API call to delete resource
            const res = await fetch(EVENTS_ENDPOINT, {
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'DELETE',
            });
            const newEvents = individualEvents.filter((evt) => evt.event_id !== id)
            toast.success('Event deleted successfully')
            setIndividualEvents(newEvents)
        
            return res
        } catch (error) {
            console.error('Error deleting resource:', error);

        } 
    };

    return (
        <EventContext.Provider
            value={{
                events,
                loading,
                fetchEvents,
                fetchUserEvents,
                postResource,
                editResource,
                deleteEvent,
                individualEvents
            }}
        >
            {children}
        </EventContext.Provider>
    );
};

export const useEvents = () => {
    const context = useContext(EventContext);
    if (!context) {
        throw new Error('useevents must be used within a Event Context Provider');
    }
    return context;
};